import React, { useEffect, useState } from 'react';
export function UrgencyBar() {
  const [timeLeft, setTimeLeft] = useState(71 * 3600 + 23 * 60 + 51);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (seconds: number) => {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor(seconds % 3600 / 60);
    const s = seconds % 60;
    return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  };
  return <div className="sticky top-0 z-50 w-full bg-[#1a0505] border-b border-red-950/60 py-2.5 px-4 flex flex-wrap items-center justify-center gap-x-3 gap-y-2 text-sm font-medium shadow-lg" data-id="element-242">
      <span className="bg-[#DC2626] text-white px-2.5 py-0.5 rounded-full text-[11px] font-bold tracking-wider flex items-center gap-1 shadow-[0_0_10px_rgba(220,38,38,0.5)]" data-id="element-243">
        <span data-id="element-244">🔥</span> 50% OFF
      </span>
      <span className="text-white tracking-wide font-semibold" data-id="element-245">
        FLASH SALE!
      </span>
      <span className="text-[#DC2626] font-mono font-bold text-base tracking-widest drop-shadow-[0_0_5px_rgba(220,38,38,0.7)]" data-id="element-246">
        {formatTime(timeLeft)}
      </span>
      <span className="text-gray-500 hidden sm:inline" data-id="element-247">|</span>
      <span className="text-gray-500 line-through text-sm" data-id="element-248">$39.99</span>
      <span className="text-gray-400" data-id="element-249">→</span>
      <span className="text-white font-bold text-base" data-id="element-250">$19.99</span>
      <span className="text-xs italic text-gray-400" data-id="element-251">(Limited time only)</span>
    </div>;
}